import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { cxdsdwe24232Service } from './bjdhfiu0';
import * as forge from 'node-forge';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EncrdecrService {
  private static scsaer = "";
  private static cduiwue3 = false;
  private static cxdwew: Promise<void> | null = null;
  private clientPrivateKeyPem: string = '';
  private nextKeyPair: Promise<{ publicKeySpkiBase64: string; privateKeyPem: string }>;

  constructor(private cxdsdwe24232Serv: cxdsdwe24232Service) { 
    if (!EncrdecrService.cxdwew) {
      EncrdecrService.cxdwew = this.df34ed();
    }
    // Pre-generate first key pair on service init
    this.nextKeyPair = this.generateKeyPair();
  }

  private async df34ed() {
    if (EncrdecrService.cduiwue3) return;
    
    EncrdecrService.scsaer = await this.cxdsdwe24232Serv.w323wetKsdsewe();
    EncrdecrService.cduiwue3 = true;
  }

  // Expose this for APP_INITIALIZER
  async dswe45refd(): Promise<void> {
    if (!EncrdecrService.cduiwue3) {
      await EncrdecrService.cxdwew;
    }
  }

  setEncr(value: string): string {
    if (!EncrdecrService.cduiwue3) {
      throw new Error('Encryption key not ready');
    }
    
    let key = CryptoJS.enc.Utf8.parse(EncrdecrService.scsaer);
    let iv = CryptoJS.enc.Utf8.parse(EncrdecrService.scsaer);
    let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
  }

  getDecr(value: string): string {

    if (!value || value.trim() === "") { 
      return "0"; 
    }

    if (!EncrdecrService.cduiwue3) {
      throw new Error('Decryption key not ready');
    }
    
    let key = CryptoJS.enc.Utf8.parse(EncrdecrService.scsaer);
    let iv = CryptoJS.enc.Utf8.parse(EncrdecrService.scsaer);
    let decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  //#region RSA Encryption

  // ─── Key Pair Management ───────────────────────────────────────────────────

  private async generateKeyPair(): Promise<{ publicKeySpkiBase64: string; privateKeyPem: string }> {
    const keyPair = await crypto.subtle.generateKey(
      { name: 'RSA-OAEP', modulusLength: 2048, publicExponent: new Uint8Array([1, 0, 1]), hash: 'SHA-256' },
      true,
      ['encrypt', 'decrypt']
    );

    // Export public key as SPKI → Base64 (matches .NET ImportSubjectPublicKeyInfo)
    const spkiBuffer = await crypto.subtle.exportKey('spki', keyPair.publicKey);
    const publicKeySpkiBase64 = this.arrayBufferToBase64(spkiBuffer);

    // Export private key as PKCS#8 → PEM (matches .NET ImportPkcs8PrivateKey)
    const pkcs8Buffer = await crypto.subtle.exportKey('pkcs8', keyPair.privateKey);
    const pkcs8Base64 = this.arrayBufferToBase64(pkcs8Buffer);
    const privateKeyPem = `-----BEGIN PRIVATE KEY-----\n${pkcs8Base64.match(/.{1,64}/g)!.join('\n')}\n-----END PRIVATE KEY-----`;

    return { publicKeySpkiBase64, privateKeyPem };
  }

  async getKeyPair(): Promise<{ publicKeySpkiBase64: string; privateKeyPem: string }> {
    const keyPair = await this.nextKeyPair;
    // Immediately start generating next key pair in background (zero wait on next call)
    this.nextKeyPair = this.generateKeyPair();
    return keyPair;
  }

  // ─── Encrypt Request ───────────────────────────────────────────────────────

  async encryptJson(payload: any, RSA_PUBLIC_KEY_BASE64: string): Promise<{ encryptedData: string; encryptedKey: string; iv: string }> {
    try {
      // Import server's RSA public key
      const publicKey = await crypto.subtle.importKey(
        'spki',
        this.base64ToArrayBuffer(RSA_PUBLIC_KEY_BASE64.trim()),
        { name: 'RSA-OAEP', hash: 'SHA-256' },
        false,
        ['encrypt']
      );

      // 1. Generate AES-256 key and IV
      const aesKey = await crypto.subtle.generateKey(
        { name: 'AES-CBC', length: 256 },
        true,
        ['encrypt', 'decrypt']
      );
      const iv = crypto.getRandomValues(new Uint8Array(16));

      // 2. Encrypt payload with AES-CBC
      const encodedPayload = new TextEncoder().encode(JSON.stringify(payload));
      const encryptedDataBuffer = await crypto.subtle.encrypt(
        { name: 'AES-CBC', iv },
        aesKey,
        encodedPayload
      );

      // 3. Export raw AES key and encrypt it with RSA-OAEP
      const rawAesKey = await crypto.subtle.exportKey('raw', aesKey);
      const encryptedKeyBuffer = await crypto.subtle.encrypt(
        { name: 'RSA-OAEP' },
        publicKey,
        rawAesKey
      );

      return {
        encryptedData: this.arrayBufferToBase64(encryptedDataBuffer),
        encryptedKey: this.arrayBufferToBase64(encryptedKeyBuffer),
        iv: this.arrayBufferToBase64(iv)
      };
    } catch (err) {
      console.error('Encryption failed:', err);
      throw err;
    }
  }

  // ─── Decrypt Response ──────────────────────────────────────────────────────

  async decryptResponse(
    encryptedDataBase64: string,
    encryptedAesKeyBase64: string,
    ivBase64: string,
    rsaPrivateKeyPem: string
  ): Promise<string> {
    // Import ephemeral RSA private key from PEM
    const pemBody = rsaPrivateKeyPem
      .replace('-----BEGIN PRIVATE KEY-----', '')
      .replace('-----END PRIVATE KEY-----', '')
      .replace(/\s+/g, '');

    const privateKey = await crypto.subtle.importKey(
      'pkcs8',
      this.base64ToArrayBuffer(pemBody),
      { name: 'RSA-OAEP', hash: 'SHA-256' },
      false,
      ['decrypt']
    );

    // 1. Decrypt AES key using RSA private key
    const decryptedAesKeyBuffer = await crypto.subtle.decrypt(
      { name: 'RSA-OAEP' },
      privateKey,
      this.base64ToArrayBuffer(encryptedAesKeyBase64)
    );

    // 2. Import decrypted raw AES key
    const aesKey = await crypto.subtle.importKey(
      'raw',
      decryptedAesKeyBuffer,
      { name: 'AES-CBC' },
      false,
      ['decrypt']
    );

    // 3. Decrypt payload with AES-CBC
    const decryptedBuffer = await crypto.subtle.decrypt(
      { name: 'AES-CBC', iv: this.base64ToArrayBuffer(ivBase64) },
      aesKey,
      this.base64ToArrayBuffer(encryptedDataBase64)
    );

    return new TextDecoder().decode(decryptedBuffer);
  }

  // ─── Helpers ───────────────────────────────────────────────────────────────

  private base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return bytes.buffer;
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    return btoa(String.fromCharCode(...new Uint8Array(buffer)));
  }
  // #endregion
}